<template>
  <wrap ref="wrap" :title="title">
    <div class="date clearBoth">
      <c-select v-model="type" color="#333" class="item select"></c-select>

      <myDatepicker
        class="item"
        format="YYYY-MM-DD HH:mm:ss"
        v-model="date_start"
      ></myDatepicker>
      <span class="item m10 search t_b-c">查询</span>
    </div>

    <CTable :head="head" :body="body">
      <!--
        自定义模版
        slot=head字段名
        slot-scope=数据索引
      -->
      <template
        slot-scope="{index}"
        slot="ts"
      >
        <a href="javascript:;" class="tc-b_h review">查 看</a>
      </template>

      <template slot="numbers" slot-scope="scope">
        <span class="numbers number3"
              :class="'number3' + i"
              v-for="(i, index) in scope.data.numbers"
              :key="'icon' + index"></span>
      </template>

      <template slot="cha"  slot-scope="scope">
        <div class="chapion">
          <span class="cha"
                v-for="(i, index) in scope.data.cha"
                :key="'cha' + index" :class="[i=='大'||i=='双'||i=='尾大' ? 'red':'blue']">{{i}}</span>
        </div>
      </template>

      <template slot="lh"  slot-scope="scope">
        <div class="chapion">
          <span class="cha"
                v-for="(i, index) in scope.data.lh"
                :key="'cha' + index" :class="[i=='龙' ? 'red' : i=='虎' ? 'blue' : ' ']">{{i}}</span>
        </div>
      </template>
    </CTable>
  </wrap>
</template>

<script>
  // qc15复用qc14
  import myDatepicker from 'vue-datepicker-local';
  import CTable from './table';
  import Wrap from "./wrap";
  import mixin from './mixin';
  import CSelect from "../c_select";

  export default {
    name: "QC15",
    mixins: [mixin],
    components: {Wrap, CTable, myDatepicker, CSelect},
    computed: {
      head () {
        return this.data.head || [
          {label: '期数', value: 'time'},
          {label: '开奖日期', value: 'date'},
          {label: '开奖号码', value: 'numbers'},
          {label: '军和', value: 'cha'},
          {label: '龙虎', value: 'lh'},
          {label: '前三', value: 'front'},
          {label: '中三', value: 'middle'},
          {label: '后三', value: 'back'},
        ];
      },
      body () {
        return this.data.body || [
          {
            time: 111,
            date: '2019-07-02 11:12:23',
            numbers: [1, 2, 3, 4, 5],
            cha: [10, '小', '双'],
            lh: '龙',
            front: '对子',
            middle: '对子',
            back: '对子'
          }
        ];
      }
    },
    data() {
      return {
        type: 0,
        date_end: '',
        date_start: ''
      };
    },
    methods: {
      disabledDate(time) {
        if (!this.date_start) return;
        return new Date(this.date_start).getTime() >= time.getTime();
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .numbers{
    margin 0 5px
  }
  .chapion{
    height 100%
    display flex
    justify-content center
    span{
      flex 1
      width 40px
      display flex
      align-items center
      justify-content center
    }
    >span+span{
      border-left 1px solid #e0e0e0
    }
  }
  .tc-b_h {
    &.review {
      color: #000000;
    }
  }

  .date {
    height: 34px;
    font-size: 14px;
    color: #000000;
    padding-bottom 10px;

    .item{
      float left
    }
    .select{
      width 140px
      height 32px
      border-radius 2px
      margin-right 10px
      background-color transparent
      border 1px solid #e0e0e0
    }
    .m10 {
      margin: 0 10px;
    }

    .search {
      display inline-block;
      height: 100%;
      color: #ffffff;
      vertical-align: top;
      line-height: 34px;
      width: 60px;
      text-align center;
      border-radius: 5px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC20.vue